import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: mocking-mike
 * id 8EF339C7-1106-40FC-B2CC-3387F915824E
 * name map-check-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-check-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapCheckOutlineIcon = createSvgIcon(<><path d="M18.25,22L15.5,19L16.66,17.82L18.25,19.41L21.84,15.82L23,17.23L18.25,22M20.5,3A0.5,0.5 0 0,1 21,3.5V13.34C20.37,13.12 19.7,13 19,13V5.7L16,6.86V13.8C15.2,14.27 14.5,14.91 14,15.68V6.87L10,5.47V17.13L13.05,18.2L13,19C13,19.46 13.05,19.92 13.15,20.35L9,18.9L3.66,20.97L3.5,21A0.5,0.5 0 0,1 3,20.5V5.38C3,5.15 3.15,4.97 3.36,4.9L9,3L15,5.1L20.34,3.03L20.5,3M5,6.46V18.31L8,17.15V5.45L5,6.46Z" /></>, 'MapCheckOutlineIcon');
export default MapCheckOutlineIcon